import gql from 'graphql-tag';
import floorFields from '@/queries/fields/floorFields';
import floorPlanFields from '@/queries/fields/floorPlanFields';
import { DollarApollo } from 'vue-apollo/types/vue-apollo';
import roomFields from '@/queries/fields/roomFields';
import lightFields, { lightLifetimeFragment, LightLifetimeFragmentData } from '@/queries/fields/lightFields';
import scenesFields from '@/queries/fields/scenesFields';
import lightModeFields from '@/queries/fields/lightModeFields';
import lightStateFields from '@/queries/fields/lightStateFields';
import DeviceState from '@/interfaces/DeviceState';

const floor = gql`
  query floor($floorId: String!) {
    floor(id: $floorId) {
      ...floorFields
    }
  }
  ${floorFields}
`;

export const floorRefetchableQuery = gql`
  query floorRefetchable($floorId: String!) {
    floor(id: $floorId) {
      ...floorFields
    }
  }
  ${floorFields}
`;

export function preloadFloor(apollo: DollarApollo<any>, floorId: string) {
  apollo.query({
    query: floor,
    variables: {
      floorId,
    },
  });
}

export const floorPlanQuery = gql`
  query floor($id: String!) {
    floor(id: $id) {
      id
      floorPlan {
        ...floorPlanFields
      }
    }
  }
  ${floorPlanFields}
`;

export const floorPlanWithDevicesQuery = gql`
  query floor($id: String!) {
    floor(id: $id) {
      id
      floorPlan {
        ...floorPlanFields
      }
      lights {
        id
        position
      }
      groups {
        id
        position
      }
      rooms {
        id
        position
      }
    }
  }
  ${floorPlanFields}
`;

export const floorWithIncludesSensorsField = gql`
  query floor($id: String!) {
    floor(id: $id) {
      id
      includesSensors
      rooms {
        id
        wifiSensingEnabled
        wifiSensingConfiguration {
          sensitivity
          beaconingNodeId
          processingNodeIds
        }
      }
    }
  }
`;

export const floorRoomsQuery = gql`
  query floor($floorId: String!) {
    floor(id: $floorId) {
      id
      rooms {
        ...roomFields
      }
    }
  }
  ${roomFields}
  ${lightFields}
`;

export const floorScenesQuery = gql`
  query floor($floorId: String!) {
    floor(id: $floorId) {
      id
      rooms {
        id
        name
        type
        displayOrder
      }
      scenes {
        ...scenesFields
      }
    }
  }
  ${scenesFields}
  ${lightModeFields}
`;

export interface FloorDevicesLifetimeQueryResult {
  floor: {
    id: string;
    rooms: {
      id: string;
      lights: LightLifetimeFragmentData[];
    }[];
  };
}
export const floorDevicesLifetimeQuery = gql`
  query floor($floorId: String!) {
    floor(id: $floorId) {
      id
      rooms {
        id
        lights {
          ...lightLifetimeFragment
        }
      }
    }
  }
  ${lightLifetimeFragment}
`;

export namespace FloorLightsWithCurrentState {

  export const query = gql`
    query floor($floorId: String!) {
      floor(id: $floorId) {
        id
        lights {
          id
          currentState {
            ...lightStateFields
          }
        }
      }
    }
    ${lightStateFields}
  `;

  export interface VariablesDefinition {
    floorId: string;
  }

  export interface ResultDefinition {
    floor: {
      id: string;
      lights: {
        id: string;
        currentState: DeviceState;
      }[];
    };
  }

}

export default floor;
